module.exports = __webpack_public_path__ + "img/4-2.9e9cc87a.png";